import { MessageOption } from "@/types/conversationTypes";

interface Props {
  option: MessageOption;
}

const AccommodationOption = ({ option }: Props) => {
  const details = option.accommodationDetails!;

  return (
    <div className="border rounded-lg overflow-hidden bg-white shadow-sm">
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div>
            <h4 className="text-base font-semibold text-gray-900">{details.name}</h4>
            <p className="text-sm text-gray-600">{details.type.charAt(0).toUpperCase() + details.type.slice(1)} • {details.area}</p>
          </div>
          <span className="text-sm font-medium text-gray-800 bg-gray-100 px-2 py-1 rounded-md">
            {details.price_range}
          </span>
        </div>
        {Array.isArray(details.highlights) && details.highlights.length > 0 && (
          <div className="mt-3">
            <ul className="mt-1 flex flex-wrap gap-2">
              {details.highlights.map((h, idx) => (
                <li key={idx} className="text-xs text-gray-700 bg-gray-100 px-2 py-1 rounded">
                  {h}
                </li>
              ))}
            </ul>
          </div>
        )}
        {details.url && (
          <a
            href={details.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center text-[11px] text-brand-600 hover:text-brand-700 font-medium underline decoration-brand-300 decoration-[1.5px] underline-offset-[3px]"
          >
            Search on Booking.com
          </a>
        )}
      </div>
    </div>
  );
};

export default AccommodationOption;